export default __webpack_public_path__ + "static/media/passport-handshake-logo.76e0e6eb.svg";